import React, { Component } from 'react';
import { Form, Col } from 'react-bootstrap';

class SelectName extends Component {

    constructor(props) {
        super(props);
        this.setName = this.setName.bind(this);
    }

    setName = (e) => {
        this.props.setName(e.target.value);
    }

    render() {
        return (
            <Col>
                <Form.Label>Name</Form.Label>
                <Form.Control placeholder="Enter keywords" onChange={this.setName} value={this.props.name} />
            </Col>
        )
    }
}

export default SelectName;



// WEBPACK FOOTER //
// ./src/components/Search/FormFields/SelectName.js